import React from "react";
import TitlePage from "../../../components/section/TitlePage/Titlepage";
import { BsChevronDown } from "react-icons/bs";
import ExpandableTable from "./Components/ExpandableTable";
import RefundInformation from "./Components/RefundInformation";
import Tabs, { Tablist } from "../../../components/ui/Tabs/Tabs";
import DetailTable from "./Components/DetailTable";
import Button from "../../../components/ui/Button/Button";
import { useOrderDetail } from "../../../api/order-management/use-order-detail";
import { useNavigate, useParams } from "react-router-dom";
import { Disclosure } from "@headlessui/react";

const tabs = [
  {
    title: "주문 현황",
    id: 1,
  },
  {
    title: "주문 취소",
    id: 2,
  },
  {
    title: "교환",
    id: 3,
  },
  {
    title: "반품",
    id: 4,
  },
];

const OrderManagementDetail = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [status, setStatus] = React.useState("");
  const { data } = useOrderDetail(id, status);
  const orderDetailData = data?.data;
  const productOrdersData = orderDetailData?.productOrders;
  const [currentTab, setCurrentTab] = React.useState(1);
  const onChangeTab = (id) => {
    setCurrentTab(id);
    switch (id) {
      case 1:
        setStatus("");
        break;
      case 2:
        setStatus("CANCELED");
        break;
      case 3:
        setStatus("EXCHANGED");
        break;
      case 4:
        setStatus("RETURNED");
        break;
      default:
        setStatus("");
        break;
    }
  };
  const handleBackToList = () => {
    navigate("/order-management");
  };

  return (
    <>
      <div className="border-b border-b-disable-grey">
        <TitlePage title="주문내역 관리 > 주문내역 상세정보" />
      </div>
      <div className="max-w-[58rem]">
        <Disclosure>
          {({ open }) => (
            <>
              <Disclosure.Button className="border-t mt-3 border-b border-[#dddddd] flex w-full justify-between py-3 text-left text-xs font-medium text-black focus:outline-none focus-visible:ring focus-visible:ring-opacity-75">
                <span className="font-bold text-sm">주문 / 결제 정보</span>
                <BsChevronDown
                  className={`transition-all ${
                    open ? "rotate-180 transform" : ""
                  } h-5 w-5 text-[#cccccc]`}
                />
              </Disclosure.Button>
              <Disclosure.Panel className="pt-4 pb-2 text-[11px]">
                <ExpandableTable data={orderDetailData} />
              </Disclosure.Panel>
            </>
          )}
        </Disclosure>
      </div>
      <div className="max-w-[58rem]">
        <h1 className="text-sm font-bold mt-8">상품정보</h1>
        <Tabs
          tabWidth="w-20"
          onChangeTab={onChangeTab}
          currentTab={currentTab}
          tabs={tabs}
        >
          <Tablist currentTab={currentTab} index={1}>
            <DetailTable
              orderDetailData={orderDetailData}
              productOrders={productOrdersData}
              showAll
            />
          </Tablist>
          <Tablist currentTab={currentTab} index={2}>
            <DetailTable
              orderDetailData={orderDetailData}
              productOrders={productOrdersData}
              showAll={null}
              filter="accepted"
            />
          </Tablist>
          <Tablist currentTab={currentTab} index={3}>
            <DetailTable
              orderDetailData={orderDetailData}
              productOrders={productOrdersData}
              showAll={null}
              filter="exchanged"
            />
          </Tablist>
          <Tablist currentTab={currentTab} index={4}>
            <DetailTable
              orderDetailData={orderDetailData}
              productOrders={productOrdersData}
              showAll={null}
              filter="returned"
            />
          </Tablist>
        </Tabs>
      </div>

      {/*  Disabled for temporary time */}
      {orderDetailData?.cancellationRefundInformation?.length ? (
        <>
          <div className="max-w-[58rem]">
            <Disclosure>
              {({ open }) => (
                <>
                  <Disclosure.Button className="border-t mt-8 border-b border-[#dddddd] flex w-full justify-between py-3 text-left text-xs font-medium text-black focus:outline-none focus-visible:ring focus-visible:ring-opacity-75">
                    <span className="font-bold text-sm">
                      주문 취소 / 반품 정보
                    </span>
                    <BsChevronDown
                      className={`transition-all ${
                        open ? "rotate-180 transform" : ""
                      } h-5 w-5 text-[#cccccc]`}
                    />
                  </Disclosure.Button>
                  <Disclosure.Panel className="pt-4 pb-2 text-[11px]">
                    <RefundInformation
                      cancellationRefundInformation={
                        orderDetailData?.cancellationRefundInformation
                      }
                    />
                  </Disclosure.Panel>
                </>
              )}
            </Disclosure>
          </div>
        </>
      ) : null}

      <div className="max-w-[58rem]">
        <div className="flex justify-end">
          <Button onClick={handleBackToList} text={`목록`} margin="mr-0 mt-6" />
        </div>
      </div>
    </>
  );
};

export default OrderManagementDetail;
